import React from 'react'

export default function Project() {
  return (
    <div id='project' className='container'>
      <h2 className="mt-5 text-center">Project 🔗</h2>
      <hr className="w-25 mx-auto" />
      <div className="row row-cols-1 row-cols-md-3 g-4">
  <div className="col">
    <div className="card h-100">
      <img src="./assets/bookwala.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">BookWala</h5>
        <p className="card-text">Contributed to the development of Bookwala,Python-based web application built with Django framework. Worked on the frontend portion of the project, ensuring an intuitive and user-friendly interface for buying and selling old
and reused books.</p>
      </div>
      <div className="card-footer text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card h-100">
      <img src="./assets/p1.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">Portfolio</h5>
        <p className="card-text">Developed a personal portfolio application using React, showcasing my skills, projects, and
professional experience.
Designed & implemented a responsive and visually appealing user interface using modern web technologies like HTML5,
CSS3, and JS</p>
      </div>
      <div className="card-footer text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card h-100">
      <img src="./assets/chatconvo.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">ConvoChat App</h5>
        <p className="card-text">Developed a ConvoChat application with messaging functionality, story feature, and profile
management capabilities. Tech: Android Studio, Java, Firebase. Implemented real-time messaging for text, story and profile.
</p>
      </div>
      <div className="card-footer text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
</div>

<div className="row row-cols-1 row-cols-md-3 g-4 mt-2">
  <div className="col">
    <div className="card h-100">
      <img src="./assets/newsapp.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">News Portal</h5>
        <p className="card-text">Develop a mobile-application which the help collect the information of news to get in the App, so that you can read the news from anywhere in this application. It supports multiple categories of news.
</p>
      </div>
      <div className="card-footer  text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card h-100">
      <img src="./assets/journey.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">Journey2Trek</h5>
        <p className="card-text">Develop a website for travelling with using Html-5 , css and Js or Bootstrap to make it responsive.</p>
      </div>
      <div className="card-footer text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card h-100">
      <img src="./assets/game.jpg" className="card-img-top" alt="..."/>
      <div className="card-body text-center">
        <h5 className="card-title">Tic Tac Toe Game</h5>
        <p className="card-text">Develop a mobile-application which the help play the tic-tac-toe game in this App, so that you can make yourself busy playing this game from anywhere through this application. </p>
      </div>
      <div className="card-footer text-center">
      <a href="/" className="btn btn-primary">Link</a>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}
